<style>
.mark {padding: 0 15px;}
h2 {font-size: 1.5rem;}
h3 {font-size: 1.2rem;}
</style>
<template lang='pug'>
  div.mark
    vue-markdown.
      ## Alpha 2.0系统使用帮助（编辑中...）
      ### 桌面
        - 显示全部客户
      ### 客户
        - 前往项目
        - 详情
      ### 项目
        #### 项目管理
          - 查看候选人
          - 查看进度
          - 查看Offer
          - 一键匹配候选人
          - 分享给
          - 详情
          - 前往项目
          - 查看某职能模块下项目
          - 编辑职级、平台、职能列
          - 编辑业务列
          - 编辑项目开发、项目对接、项目经理、项目组成列
        #### 项目进度
          - 查看Offer
          - 发送推荐报告
          - 参加面试
          - 收到offer
          - 收到回款
          - checklist
        #### offer
      ### 候选人
        #### searchlist列表
          - 分享给
        #### 候选人列表
          - 将选中的数据复制到
          - 将选中的数据移动到下一行
          - 在下方插入行
          - 分享给
          - 详情
      ### 公告
        - 新建公告
        - 上传附件
        - 附件下载
        - 详情
      ### 其它
        #### 行业公司
        #### 职能模块
        #### 文件上传
        #### 会谈问题
      ### 管理
        #### KPI
        #### 用户
        #### 用户组
        #### 系统日志
      ### 使用帮助
      ### 个人中心
        #### 个人KPI
        #### 修改密码
        #### 注销

      ### 通用操作
        - 新增数据
        - 移动光标
        - 编辑数据
          - 表内编辑
          - 展开编辑
          - 详情编辑
        - 删除选中的行
        - 权限
        - 隐藏列
        - 列筛选
        - 从excel导入数据
        - 表内搜索
        - 全站搜索
          
</template>
<script>
// Generated by CoffeeScript 2.3.0
var m;

import VueMarkdown from 'vue-markdown';

export default m = {
  components: {
    'vue-markdown': VueMarkdown
  }
};
</script>
